export const REFER_AND_EARN_SCREEN_NAME = "Refer & Earn";
